<cue-declarative-map-layer
  pane="resource"
  (click)="onLayerClick()"
  [interactive]="true"
  [fill]="true"
  [radius]="radius()"
  [fitMap]="fitMap()"
  [weight]="weight()"
  [fillOpacity]="fillOpacity()"
  [fillColor]="fillColor()"
  [color]="color()"
  [geoJson]="geoJson()"
/>
